export const getUrlKey = (name: string) =>{//获取url 参数
  const re = new RegExp('[?|&]'+name+'='+'([^&;]+?)(&|#|;|$)').exec(location.href)||[""]
  const s = re[1]?.replace(/\+/g,'%20')
  if(s){
    return decodeURIComponent(s)
  }
  return null;
}